import { IDeleteAcoesPreventivasUseCase } from "../../../presentation/useCases/delete/delete_acoes_preventivas_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteAcoesPreventivasUseCase


export class DeleteAcoesPreventivasUseCase implements IDeleteAcoesPreventivasUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteAcoesPreventivas( IdAcaoQualidade: number): Promise<void> {
    
    await this.repository.deleteAcoesPreventivas( IdAcaoQualidade );
  }
}
